module.exports = __webpack_public_path__ + "img/制御工学5_1_1.2c360029.png";